// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_stamp__W7XSe {
  margin: 0.5rem 0rem; }
  .styles_stamp__W7XSe p {
    font-size: 1.5rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/booths/components/BoothInfo/styles.module.scss"],"names":[],"mappings":"AAAA;EAII,mBAAmB,EAAA;EAJvB;IAEQ,iBAAiB,EAAA","sourcesContent":[".stamp {\n    p {\n        font-size: 1.5rem;\n    }\n    margin: 0.5rem 0rem; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stamp": `styles_stamp__W7XSe`
};
export default ___CSS_LOADER_EXPORT___;
